import {Role, CreateRoleRequest} from '../models/role.model';

// API Response DTO interface
export interface RoleDTO {
  id: number;
  name: string;
  display_name: string;
  description: string;
  permissions: string[];
  user_count: number;
  is_system: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

// API Response wrapper — matches the backend envelope
// (mirrors UsersListResponseDTO in user.dto.ts)
export interface RolesListResponseDTO {
  stat_code: number;
  stat_message: string;
  data: RoleDTO[];
  error: string | null;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// DTO to Model Mappers
export const mapRoleDTOToModel = (dto: RoleDTO): Role => {
  return {
    id: dto.id,
    name: dto.name,
    displayName: dto.display_name,
    description: dto.description,
    permissions: dto.permissions,
    userCount: dto.user_count,
    isSystem: dto.is_system,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at
  };
};

export const mapRolesListResponseToModel = (dto: RolesListResponseDTO): { roles: Role[]; pagination: RolesListResponseDTO['pagination'] } => {
  return {
    roles: (dto.data || []).map(mapRoleDTOToModel),
    pagination: dto.pagination
  };
};

// Request DTO interfaces
export interface CreateRoleRequestDTO {
  name: string;
  display_name: string;
  description: string;
  permissions: string[];
  is_system: boolean;
}


// Model to DTO Mappers (for sending to API)
export const mapCreateRoleRequestToDTO = (request: CreateRoleRequest): CreateRoleRequestDTO => {
  return {
    name: request.name,
    display_name: request.displayName,
    description: request.description,
    permissions: request.permissions,
    is_system: false // Default to false for new roles
  };
};

